import {type} from '../../common/utils';
import {ActionLocal} from "./actions.service";

export type AnalyticsData = {details: any} & Partial<{tag: any, topology: string, cpn: string, rpn: string, module: string}>;
export class AnalyticsActions {

  static ActionType = {
    SEND_EVENT: type('[AnalyticsActions] SEND_EVENT'),
    SEND_EXCEPTION: type('[AnalyticsActions] SEND_EXCEPTION'),
  };

  public static sendAnalyticsEvent(name: string, category: string, data: AnalyticsData): ActionLocal {
    return {
      type: AnalyticsActions.ActionType.SEND_EVENT,
      payload: {name, category, data}
    };
  }

  public static sendAnalyticsException(error: string): ActionLocal {
    return {
      type: AnalyticsActions.ActionType.SEND_EXCEPTION,
      payload: error
    };
  }
}
